import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Leaf } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { toast } from "sonner";

import { GoogleButton } from "./Login";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const product = params.get("product") || "";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Account created. Choose your evaluation to continue.");
      navigate("/app", { state: { product } });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF8] noise-bg flex items-center justify-center px-6">
      <div className="card-warm w-full max-w-md p-10">
        <Link to="/" className="flex items-center gap-2 mb-8" data-testid="register-brand-link">
          <span className="h-9 w-9 rounded-full bg-[#1E3F20] flex items-center justify-center"><Leaf className="h-4 w-4 text-[#FAFAF8]" /></span>
          <span className="font-heading text-lg font-semibold tracking-tight">Assessment Center</span>
        </Link>
        <h1 className="font-heading text-3xl font-semibold tracking-tight" data-testid="register-heading">Create your account</h1>
        <p className="text-sm text-[#5C5C57] mt-2 mb-8">Your information is confidential and stored securely.</p>
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="name">Full name</Label>
            <Input id="name" required data-testid="register-name-input" value={name}
              onChange={(e) => setName(e.target.value)} className="input-warm border-[#E5E5DF]" autoComplete="name" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required data-testid="register-email-input" value={email}
              onChange={(e) => setEmail(e.target.value)} className="input-warm border-[#E5E5DF]" autoComplete="email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password (8+ characters)</Label>
            <Input id="password" type="password" required minLength={8} data-testid="register-password-input" value={password}
              onChange={(e) => setPassword(e.target.value)} className="input-warm border-[#E5E5DF]" autoComplete="new-password" />
          </div>
          <Button type="submit" disabled={loading} data-testid="register-submit-button"
            className="w-full rounded-full bg-[#1E3F20] hover:bg-[#2C5A2E] text-white h-11 transition-colors">
            {loading ? "Creating…" : "Create account"}
          </Button>
        </form>
        <GoogleButton />
        <p className="text-sm text-[#5C5C57] mt-6">
          Already have an account? <Link to="/login" className="text-[#1E3F20] font-semibold hover:underline" data-testid="register-login-link">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
